module.exports = __webpack_public_path__ + "img/markers-soft.02f9178c.png";